export const SET_PORTAL_SESSION    = 'SET_PORTAL_SESSION';
export const REMOVE_PORTAL_SESSION = 'REMOVE_PORTAL_SESSION';
